// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("DailyDeal", {
  id: __t.u64(),
  userId: __t.u64(),
  itemId: __t.u64(),
  discountPercent: __t.u32(),
  dealDate: __t.u64(),
  slotIndex: __t.u32(),
  purchased: __t.bool(),
});


